module.exports = __webpack_public_path__ + "static/media/normal.1169f10e.gif";